module.exports = __webpack_public_path__ + "img/img40.a0362eef.png";